import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'flux/utils';
import { CertificateDialogs } from '../../constants/Dialogs';
import { browserHistory } from 'react-router';
import ROLES from '../../constants/Roles';

import DetailView from '../Common/DetailView';
import { Card, CardActions, CardHeader } from 'material-ui/Card';
import CertificateFieldDialog from './CertificateFieldDialog';
import FlatButton from 'material-ui/FlatButton';
import LinearProgress from 'material-ui/LinearProgress';
import { List, ListItem } from 'material-ui/List';
import ErrorSnackbar from '../Common/ErrorSnackbar';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import InfoIcon from 'material-ui/svg-icons/action/info';
import CertificateIcon from 'material-ui/svg-icons/action/verified-user';

import CertificateActions from '../../actions/CertificateActionCreator';
import CertificateStore from '../../stores/CertificateStore';
import DialogActions from '../../actions/DialogActionCreator';
import DialogStore from '../../stores/DialogStore';

import buildContextMenu from '../Common/BuildContextMenu';
import { statusColours } from '../../constants/ColourConstants';
import { withId } from '../Common/Decorators';

const defaultField = () => ({
    id: Date.now(),
    name: '',
    baseX: 10,
    baseY: 10,
    width: null,
    height: null,
    colour: '#000',
    fontSize: 16,
    font: null,
    textAlign: 'left'
});

const fieldListItem = (field) => {

    const style = {
        text: {
            color: field.colour,
            fontSize: field.fontSize,
            position: 'relative',
        }
    };

    return (
        <ListItem
            key={field.id}
            primaryText={<span style={style.text}>{field.name}</span>}
            secondaryText={`(${field.baseX},${field.baseY})  Font: ${field.font} `}
            onTouchTap={() => DialogActions.open(CertificateDialogs.FIELD_EDIT, field)}
        />
    )
};

const style = {
    icon: {
        height: '32px',
        width: '32px'
    }
};

const getMenuItems = (id) => [
    {
        link:   `/cent/certificate/${id}/preview.pdf`,
        icon:   <InfoIcon />,
        label:  'Preview',
        target: '_blank'
    },
    {
        type: 'divider'
    },
    {
        link: `/dashboard/certificate/${id}/edit`,
        icon: <EditIcon />,
        label: 'Edit',
        condition: {
            roles: [ROLES.ADMIN]
        }
    },
    {
        type: 'deleteDialog',
        dialogType: 'menu',
        value: id,
        title: 'Delete',
        condition: {
            roles: [ROLES.ADMIN]
        },
        deleteAction: (id) => {
            CertificateActions
                .delete(id)
                .then(browserHistory.push('/dashboard/certificates'));
        },
        message: (<span>Are you sure you want to delete this certificate?</span>)
    }
];


class Certificate extends Component {

    componentWillMount() {
        this.setState({actions: buildContextMenu(getMenuItems(this.props.id), this.context.auth)});
    }

    componentDidMount() {
        this.updateField = this.updateField.bind(this);
        CertificateActions.getById(this.props.id);
    }

    getDialog() {
        switch (this.state.dialog) {
            case CertificateDialogs.FIELD_ADD:
                return (<CertificateFieldDialog onSave={(draft) => CertificateActions.addField(this.props.id, draft)} />);

            case CertificateDialogs.FIELD_EDIT:
                const onRemove = (field) => CertificateActions.removeField(this.props.id, field);
                return (<CertificateFieldDialog onSave={this.updateField} onRemove={onRemove} />);

            default:
                return null;
        }
    }

    render() {

        if (!this.state.certificate) { return <DetailView/>; }
        const {actions, isFetching, certificate} = this.state;

        // TODO: we should receive canEdit and canDelete properties from backEnd
        const canEdit = this.context.auth.isAdmin();

        const cardHeaderProps = (canEdit) ? {
            openIcon: <EditIcon onClick={() => this.editAction()}/>,
            closeIcon: <EditIcon onClick={() => this.editAction()}/>,
            showExpandableButton: true,
            expandable: false
        } : {};

        return (
            <DetailView
                backButton={true}
                actions={actions}
            >
                <div className="cent-cards">
                    <Card className="cent-card">
                        <CardHeader {...cardHeaderProps}
                            className="cent-card-header"
                            title={certificate.name}
                            subtitle={certificate.paperSize}
                            avatar={(<CertificateIcon style={style.icon} color={statusColours['default']}/>)}
                        />
                        <List>
                            {(certificate.fields && certificate.fields.length > 0) && certificate.fields.map(fieldListItem, this)}
                        </List>
                        {canEdit &&
                            <CardActions>
                                <FlatButton
                                    label="Add"
                                    onTouchTap={() => DialogActions.open(CertificateDialogs.FIELD_ADD, defaultField())}
                                />
                            </CardActions>
                        }
                        {!!isFetching && <LinearProgress/>}
                    </Card>
                </div>
                {this.getDialog()}
                <ErrorSnackbar/>
            </DetailView>
        );
    }

    updateField(draft) {
        const current = this.state.certificate.fields.find(cert => cert.id === draft.id);
        CertificateActions.updateField(this.props.id, current, draft);
    }

    editAction()  {
        browserHistory.push(`/dashboard/certificate/${this.props.id}/edit`);
    }
}

Certificate.getStores = () => ([CertificateStore, DialogStore]);
Certificate.calculateState = (prevState, { id } ) => ({
    dialog: DialogStore.getOpenDialog(),
    isFetching: CertificateStore.isFetching(),
    certificate: CertificateStore.getById(id),
    actions: (!!prevState && prevState.actions) || []
});

Certificate.contextTypes = {
    auth:   PropTypes.object
};

export default withId(Container.create(Certificate, {withProps: true}));
